import React, { Component } from "react";
import styled from "styled-components";
import Slider from "./components/Slider";
import StarChart from "./components/StarChart";
import calcSspDeviation from "./utils/calcSspDeviation";

import "./App.css";

const ChartWrapper = styled.div`
  // border: 1px solid red;
  display: flex;
  flex-wrap: wrap;
  // position: absolute;
`;
const HeaderStyled = styled.div`
  // border: 1px solid black;
  color: black;
  display: flex;
  margin: 20px 0 70px 0;
`;
const LabelStyled = styled.div`
  // border: 1px solid black;
  cursor: pointer;
  font-weight: 600;
  padding: 0 35px 0 6px;
`;
const SliderStyled = styled.div`
  // border: 1px solid black;
  padding: 0 35px 0 0;
  text-transform: capitalize;
  width: 40%;
`;
const ViewToggleStyled = styled.div`
  display: flex;
  font-weight: 400;
  margin-top: 9px;

  .nav-item {
    font-size: 14px;
    margin-left: -5px;
    margin-right: 15px;
    padding: 1px 4px;
    text-transform: capitalize;
    user-select: none;
  }

  .active {
    background-color: black;
    border-radius: 2px;
    color: white;
    font-weight: 300;
  }
  .inactive {
    cursor: not-allowed;
    color: #999;
  }
`;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      year: 2010,
      benchmarkSsp: 2,
      innerRadius: 75,
      starView: false,
      showArcs: false,
      armWidth: 16
    };
  }
  handleYears = year => {
    this.setState({ year });
  };
  handleRadius = innerRadius => {
    this.setState({ innerRadius });
  };
  handleArmWidth = armWidth => {
    this.setState({ armWidth });
  };
  render() {
    const categories = [
      "coal",
      "gas",
      "hydro",
      "nuclear",
      "oil",
      "solar",
      "wind"
    ];
    const ssps = [1, 2, 3, 4, 5];
    const deviationData = ssps.map(ssp =>
      calcSspDeviation.currentYear({
        year: this.state.year,
        ssp,
        benchmarkSsp: this.state.benchmarkSsp
      })
    );

    return (
      <div className="App">
        <HeaderStyled>
          <LabelStyled
            onClick={() => {
              return null;
            }}
          >
            {"Dataset"}
            <ViewToggleStyled>
              <div className={`nav-item active`}>{"Energie"}</div>
              <div className={`nav-item inactive`}>{"GDP"}</div>
              <div className={`nav-item inactive`}>{"Emissions"}</div>
            </ViewToggleStyled>
          </LabelStyled>

          <SliderStyled>
            <Slider
              value={this.state.year}
              sliderCallback={this.handleYears}
              label={"Projected Year"}
              min={2010}
              max={2100}
              step={10}
              dots
            />
          </SliderStyled>

          <LabelStyled
            onClick={() => {
              this.setState({ starView: !this.state.starView });
            }}
          >
            {"View"}
            <ViewToggleStyled>
              <div
                className={`nav-item ${this.state.starView ? "" : "active"}`}
              >
                {"bar"}
              </div>
              <div
                className={`nav-item ${this.state.starView ? "active" : ""}`}
              >
                {"star"}
              </div>
            </ViewToggleStyled>
          </LabelStyled>
        </HeaderStyled>
        <ChartWrapper>
          {categories.map(c => {
            const starData = deviationData.map(
              d => d[categories.findIndex(cat => cat === c)]
            ); // get category
            return (
              <StarChart
                category={c}
                height={window.innerWidth / 4 - 60}
                width={window.innerWidth / 4 - 60}
                innerRadius={this.state.innerRadius}
                index={0}
                year={this.state.year}
                starData={starData}
                starView={this.state.starView}
                benchmarkSsp={this.state.benchmarkSsp}
                showArcs={this.state.showArcs}
                armWidth={this.state.armWidth}
              />
            );
          })}
        </ChartWrapper>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js